import React from "react";
import { Navigate, RouteObject } from "react-router-dom";
import EditProfile from "../pages/pro/createEditProfile/EditProfile";
import BrandSettings from "../pages/brand/settings/Settings";

import BrandSettingsResetPassword from "../pages/brand/settings/ResetPassword";
import BrandDetailApiKeysTab from "../pages/brand/settings/apiKeys/BrandDetailApiKeysTab";
import BrandDetailOnboardingTab from "../pages/brand/settings/BrandDetailOnboardingTab";
import BrandDetailSearchConsoleTab from "../pages/brand/settings/BrandDetailSearchConsoleTab";

import MyProfile from "../pages/profile/MyProfile";
import ServiceKeysPage from "../pages/brand/settings/serviceKeys/ServiceKeysPage";
import SignInMethods from "../components/auth/SignInMethods";
import AllBrands from "../pages/brand/AllBrands";
import BrandProjectsCreate from "../pages/brand/create_project/BrandProjectsCreate";
// import ProjectDetail from '../pages/brand/ProjectDetail'
import EditProject from "../pages/brand/EditProject";
import BrandDetail from "../pages/brand/BrandDetail";
import { RouteRoleGuard } from "../layouts/RouteRoleGuard/RouteRoleGuard";
import { LayoutAdmin } from "../layouts/Admin/Admin";
import InternalDashboard from "../pages/internalDashboard/InternalDashboard";
import TutorialsList from "../pages/tutorials/TutorialsList";
import BrowseUsers from "../pages/admin/BrowseUsers";
import AdminEditUser from "../pages/admin/User/edit";
import AdminCreateUser from "../pages/admin/User/create";
import {
    BrowseProPaths,
    VideoPaths,
    BrandTeamCreateProjectDistribution,
    ExpertProfilePath
} from "../components/Header/configuration/navs";
import AllProducts from "../pages/products/AllProducts";
import { BrandTeamMembers } from "../pages/brand/team";
import BrandProjects from "../pages/brand/BrandProjects";
import { ProExportPDF } from "../pages/pro/Export";
import { ProfessionsPage } from "../pages/professions/ProfessionsPage";
import { AreasOfFocusPage } from "../pages/areasOfFocus/AreasOfFocusPage";
import SingleProduct from "../pages/products/SingleProduct";
import Shortlists from "../pages/admin/Shortlists";
import ShortlistProlisting from "../pages/pro/Listing/ShortlistProlisting";
import QrGenerator from "../pages/admin/qrGenerator";
import SingleQr from "../pages/admin/qrGenerator/SingleQr";
import Categories from "../pages/admin/categories";
import ProductCategories from "../pages/admin/productCategories";
import Attributes from "../pages/admin/attributes";
import ExpertIQ from "../pages/admin/expertIQ";
import CreateProfile from "../pages/pro/createEditProfile/CreateProfile";
import VideoProduction from "../pages/videoProduction/VideoProduction";
import ExpertSelection from "../pages/videoProduction/expertSelection";
import ConfirmationDetails from "../pages/pro/projects/ConfirmationDetails";
import OrdersPage from "../pages/orders";
import SOWPage from "../pages/sow";
import SalesAdmin from "../pages/sales/SalesAdmin";
import ProposalDetailPage from "../pages/sales/proposals/ProposalDetailPage";

import BrandNotificationSettings from "../pages/brand/settings/notification/Notification";
import { SingleBrandDetails } from "../pages/brand/SingleBrandDetails";
import { ProductsPanel } from "../pages/brand/brandDetailProducts";
import { BrandDetailExpertsPanel } from "../pages/brand/BrandDetailExpertsPanel";
import BrandContentTypesPage from "../pages/brand/BrandContentTypesPage";
import BrandFileTypesPage from "../pages/brand/BrandFileTypesPage";
import BrandRmnPage from "../pages/brand/rmn/BrandRmnPage";
import PricingPage from "../pages/admin/pricing";
import PlanPricingPage from "../pages/planPricing/PricingPage";
import BrandUsagePage from "../pages/admin/brandUsage/BrandUsagePage";
import BrandUsageDetailPage from "../pages/admin/brandUsage/BrandUsageDetailPage";
import ModelRunsPage from "../pages/admin/autopilot/ModelRunsPage";

/**
 * RouterRoleGuard will check for the role of current user
 * Layout Admin => default layout with header for admin
 */

export const AdminRoutes: RouteObject[] = [
    {
        path: "/",
        element: (
            <RouteRoleGuard role="ADMIN">
                <LayoutAdmin />
            </RouteRoleGuard>
        ),
        children: [
            {
                path: "",
                element: <Navigate to="/dashboard" />
            },
            {
                path: "dashboard",
                element: <InternalDashboard />
            },
            ...BrowseProPaths,
            ...ExpertProfilePath,
            ...BrandTeamCreateProjectDistribution, // Distributions
            ...VideoPaths,
            {
                path: "products/:brandId",
                element: <SingleProduct />
            },
            {
                path: "products",
                element: <AllProducts />
            },
            {
                path: "experts/create",
                element: <CreateProfile />
            },
            {
                path: "experts/:id/:slug/edit",
                element: <EditProfile />
            },
            {
                path: "/exportpdf",
                element: <ProExportPDF />
            },
            {
                path: "/professions",
                element: <ProfessionsPage />
            },
            {
                path: "/areas-of-focus",
                element: <AreasOfFocusPage />
            },
            {
                path: "users",
                element: <BrowseUsers />
            },
            {
                path: "users/:id/admin-edit",
                element: <AdminEditUser />
            },
            {
                path: "users/admin-create",
                element: <AdminCreateUser />
            },
            {
                path: "brands",
                element: <AllBrands />
            },
            {
                path: "brands/:id",
                element: <SingleBrandDetails />,
                children: [
                    {
                        path: "",
                        element: <Navigate to="/brands/:id/details" />
                    },
                    {
                        path: "details",
                        element: <BrandDetail />
                    },
                    {
                        path: "team",
                        element: <BrandTeamMembers />
                    },
                    {
                        path: "products",
                        element: <ProductsPanel />
                    },
                    {
                        path: "experts",
                        element: <BrandDetailExpertsPanel />
                    },
                    {
                        path: "content-types",
                        element: <BrandContentTypesPage />
                    },
                    {
                        path: "file-types",
                        element: <BrandFileTypesPage />
                    },
                    {
                        path: "api-keys",
                        element: <BrandDetailApiKeysTab />
                    },
                    {
                        path: "onboarding",
                        element: <BrandDetailOnboardingTab />
                    },
                    {
                        path: "google-tag",
                        element: <Navigate to="../onboarding" replace />
                    },
                    {
                        path: "search-console",
                        element: <BrandDetailSearchConsoleTab />
                    },
                    {
                        path: "rmn",
                        element: <BrandRmnPage />
                    }
                ]
            },
            // {
            //   path: 'brands/:id/projects',
            //   element: <BrandProjects />,
            // },
            // {
            //   path: 'brands/:brand_id/project/:project_id/detail',
            //   element: <ProjectDetail />,
            // },
            // {
            //   path: 'brands/:brand_id/project/:project_id/edit',
            //   element: <EditProject />,
            // },
            // {
            //   path: 'brands/:brand_id/project/:project_id/create',
            //   element: <BrandProjectsCreate />,
            // },
            {
                path: "/experts/shortlists",
                element: <Shortlists />
            },
            {
                path: "/experts/shortlists/:id",
                element: <ShortlistProlisting />
            },
            // Content types / channels / placements / categories are now tabs
            // on the pricing page.
            {
                path: "/brands/content-types",
                element: <Navigate to="/admin/pricing" replace />
            },
            {
                path: "/brands/content-types/*",
                element: <Navigate to="/admin/pricing" replace />
            },
            {
                path: "video-production/orders",
                element: <OrdersPage />
            },
            {
                path: "video-production/sow",
                element: <SOWPage />
            },
            {
                path: "video-production/projects",
                element: <VideoProduction />
            },
            {
                path: "/video-production/projects/:projectId",
                element: <ExpertSelection />
            },
            {
                path: "/video-production/projects/:projectId/experts/:userId/confirmation",
                element: <ConfirmationDetails />
            },
            {
                path: "sales/leads",
                element: <SalesAdmin />
            },
            {
                path: "sales/pdp-audit-reports",
                element: <SalesAdmin />
            },
            {
                path: "sales/consumer-voice-reports",
                element: <SalesAdmin />
            },
            {
                path: "sales/ai-presence-reports",
                element: <SalesAdmin />
            },
            {
                // Brand Intelligence renders as a tab of the Sales page.
                path: "sales/prep-packs",
                element: <SalesAdmin />
            },
            {
                // Proposals render as a tab of the Sales page (Leads | PDP
                // Audit Reports | Proposals).
                path: "sales/proposals",
                element: <SalesAdmin />
            },
            {
                path: "sales/proposals/:id",
                element: <ProposalDetailPage />
            },
            // {
            //   path:'/experts/shortlists/:id',
            //   element: <Shortlists/>
            // },
            {
                path: "qr-generator",
                element: <QrGenerator />
            },
            {
                path: "categories",
                element: <Categories />
            },
            {
                path: "admin/pricing",
                element: (
                    <RouteRoleGuard roles={["ADMIN", "ACCOUNT_MANAGER_ADMIN"]}>
                        <PricingPage />
                    </RouteRoleGuard>
                )
            },
            {
                // Plan comparison table (plans as columns). Internal-only
                // since 2026-09-16 — it used to be a public embed.
                path: "pricing",
                element: (
                    <RouteRoleGuard role="INTERNAL">
                        <PlanPricingPage />
                    </RouteRoleGuard>
                )
            },
            // Old per-section URLs (e.g. /admin/pricing/licenses) — now tabs on the page.
            {
                path: "admin/pricing/*",
                element: <Navigate to="/admin/pricing" />
            },
            {
                path: "admin/autopilot/model-runs",
                element: (
                    <RouteRoleGuard role="INTERNAL">
                        <ModelRunsPage />
                    </RouteRoleGuard>
                )
            },
            {
                path: "admin/brands/usage",
                element: (
                    <RouteRoleGuard roles={["ADMIN", "ACCOUNT_MANAGER_ADMIN"]}>
                        <BrandUsagePage />
                    </RouteRoleGuard>
                )
            },
            {
                path: "admin/brands/:id/usage",
                element: (
                    <RouteRoleGuard roles={["ADMIN", "ACCOUNT_MANAGER_ADMIN"]}>
                        <BrandUsageDetailPage />
                    </RouteRoleGuard>
                )
            },
            {
                path: "product-categories",
                element: <ProductCategories />
            },
            {
                path: "attributes",
                element: <Attributes />
            },
            {
                path: "experts/expert-iq",
                element: <ExpertIQ />
            },
            {
                path: "qr/:id",
                element: <SingleQr />
            },
            // {
            //   path: 'profile/me',
            //   element: <Navigate to="/settings/profile" />,
            // },
            {
                path: "settings/*",
                element: <BrandSettings />,
                children: [
                    {
                        path: "",
                        element: <Navigate to="/settings/profile" />
                    },
                    {
                        path: "profile",
                        element: <MyProfile />
                    },
                    {
                        path: "reset-password",
                        element: <BrandSettingsResetPassword />
                    },
                    {
                        path: "notifications",
                        element: <BrandNotificationSettings />
                    },
                    {
                        // Personal API Keys (service account keys)
                        path: "personal-keys",
                        element: <ServiceKeysPage />
                    },
                    {
                        // Password + Google (components/auth/SignInMethods)
                        path: "sign-in-methods",
                        element: <SignInMethods />
                    },
                    {
                        path: "*",
                        element: <Navigate to="/404" />
                    }
                ]
            },
            {
                path: "tutorials",
                element: <TutorialsList />
            },
            {
                path: "*",
                element: <Navigate to="/404" />
            }
        ]
    }
];
